module.exports = __webpack_public_path__ + "img/loading.be2c5ba6.gif";